import { vehicleTireAccessoriesFields } from './vehicleConfiguration';

export const getVehicleAccessoriesWithSerialNumberQuery = `
  query getVehicleAccessoriesBySerialNumber($serialNo: String!) {
    getVehicleAccessoriesBySerialNumber(serialNo: $serialNo) {
      ${vehicleTireAccessoriesFields}
    }
  }
`;
